export enum PICKING_STATE {
  Start = "start",
  End = "end"
}

export enum SLIDE_DIRECTION {
  Left = "left",
  Right = "right"
}

export enum SLIDE_CLASS {
  Idle = "idle",
  ExitLeft = "exit-left",
  ExitRight = "exit-right",
  EnterLeft = "enter-left",
  EnterRight = "enter-right"
}

export enum CELL_ROLE {
  Start = "start",
  End = "end",
  Middle = "middle",
  None = "none"
}

export enum VIEW_MODE {
  Day = "day",
  Month = "month",
  Year = "year"
}
